export default "__VITE_ASSET__250b8f92__"